import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Button } from "components/Button/Button";
import { Input, Select, TextArea } from "components/Form";
// import {
//   deleteCourseSubCategory,
//   getIpAccess,
//   updateCourseSubCategoryStatus,
//   updateMenuStatus,
// } from "services/course/AccessList";
import DeleteIcon from "@mui/icons-material/Delete";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
// import { getCourseCategory } from "services/master";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "components/Button/IconButton";
import { Pagination } from "@mui/material";
import { getContactList } from "services/contactus";

export default function ContactUs() {
  const navigate = useNavigate();
  const [record, setRecord] = useState([]);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [description,setDescription] = useState("")

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getContactList({
        page: activePage,
        search: search,
        limit: limit,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.contacts;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total > limit) {
          setPageCount(Math.round(count / limit) + 1);
        } else {
          setPageCount(Math.round(count / limit) + 1);
        }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage, search]);

  return (
    <React.Fragment>
      {/* <title>Contact Us Page</title> */}
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap w60per">
                <div className="SearchBox w-100 " style={{ gap: "2px" }}>
                  <div className="div_wrap mx-1 w40per"></div>
                  <div className="div_wrap mx-1 w20per"></div>
                  <div className="div_wrap mx-1 w40per">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h4 className="Title">Contact Us</h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Email Id</th>
                    <th>Address</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          id,
                          Name,
                          Mobile,
                          EmailID,
                          Address,
                          Message,
                          AddedOn,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td>{++i + (activePage - 1) * 10}</td>
                          {/* {/ <td>{courseCategory?.CourseTypeDesc}</td> /} */}
                          <td >{Name}</td>
                          <td >{Mobile}</td>
                          <td >{EmailID}</td>
                          <td >{Address}</td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <IconButton
                                aria-label="view"
                                className="px-2 py-0"
                                onClick={() => {
                                    setViewModal(true);
                                    setDescription(Message);
                                }}
                              >
                                <VisibilityIcon sx={{ color: "#4971B2" }} />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  siblingCount={2}
                  page={activePage}
                  count={pageCount}
                  onChange={(e, value) => {
                    setActivePage(value);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* *********************************** View Message ************************************* */}
      <ModalBox
        status={viewModal}
        onClose={() => setViewModal(false)}
        size={"sm"}
        title={"Message"}
        description={description}
        customizedFooter={true}
        Close={true}
        custom={false}
      />
    </React.Fragment>
  );
}
